import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Handler from "../../Helpers/Handler";
import { formatDateTime } from "../../Helpers/Utils";

// KYC Rejections (Phase 5.7): document numbers someone tried to add that are already on another
// account (possible fraud). Both accounts are shown here; the customer is only ever told the
// document is linked to another account. Loaded when opened. Same file in the admin and staff panels.
const DOC_LABEL = { aadhaar: "Aadhaar", dl: "Driving licence", voter: "Voter ID", passport: "Passport" };

const Person = ({ person, onOpen }) => (person ? (
    <button type="button" className="btn btn-link btn-sm p-0 text-start" onClick={() => onOpen(person.customerId)}>
        {person.name || person.customerId}<span className="text-muted"> · {person.phone || person.customerId}</span>
    </button>
) : <span className="text-muted">-</span>);

const DuplicateAlerts = ({ basePath = "/admin/customer" }) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState(null);
    const [error, setError] = useState(null);

    const toggle = async () => {
        const next = !open;
        setOpen(next);
        if (next && rows === null) {
            const response = await Handler({ method: "GET", url: `${basePath}/kyc/duplicates` });
            if (response?.success) setRows(response?.data?.data?.alerts || []);
            else { setRows([]); setError(response?.data?.message || "Could not load the alerts"); }
        }
    };

    return (
        <div className="card border-0 shadow-sm rounded-4 mb-3">
            <div className="card-body py-2 d-flex align-items-center justify-content-between">
                <span className="fw-semibold small">Duplicate KYC documents</span>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={toggle} aria-expanded={open}>{open ? "Hide" : "Show"}</button>
            </div>
            {open && (
                <div className="card-body pt-0">
                    {rows === null ? <div className="small text-muted">Loading...</div> : error ? <div className="small text-danger">{error}</div> : rows.length === 0 ? (
                        <div className="small text-muted">No duplicate documents so far.</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-sm align-middle mb-0 small">
                                <thead><tr><th>When</th><th>Document</th><th>Tried by</th><th>Already on</th><th>Via</th></tr></thead>
                                <tbody>
                                    {rows.map((row) => (
                                        <tr key={row.attemptId}>
                                            <td>{formatDateTime(row.createdAt)}</td>
                                            <td>{DOC_LABEL[row.documentType] || row.documentType}{row.documentNumber ? <span className="text-muted"> · {row.documentNumber}</span> : null}</td>
                                            <td><Person person={row.customer} onOpen={(id) => navigate(`/customers/${id}`)} /></td>
                                            <td><Person person={row.otherCustomer} onOpen={(id) => navigate(`/customers/${id}`)} /></td>
                                            <td className="text-capitalize">{row.source}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DuplicateAlerts;
